/**
 * AM.One API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Safe conflict response for an active full reindex.
 */
export interface ReindexConflictError { 
    code: ReindexConflictError.CodeEnum;
    message: string;
}
export namespace ReindexConflictError {
    export const CodeEnum = {
        ReindexAlreadyRunning: 'REINDEX_ALREADY_RUNNING'
    } as const;
    export type CodeEnum = typeof CodeEnum[keyof typeof CodeEnum];
}


